import React from 'react'
import { useFormContext } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";

const Percent = ({ field_id, field_label, field_placeholder, field_value, validation, default_value }) => {

    const { register, errors } = useFormContext();
    // Always an object so validationObj.required never throws when a field has
    // no (or malformed) validation config.
    let validationObj = {};
    try {
        validationObj = validation ? JSON.parse(validation) : {};
    } catch (e) {
        validationObj = {};
    }

    // Inputmask removed (see Currency.js) — native type="number" is caret-stable
    // and numeric-safe; the backend strips $ , % so the wire format is unchanged.
    const checkMinMaxValue = (value) => {
        var formattedVal = Number(value.replaceAll("%", "")).toFixed(4);
        if (field_id == "annual_hpi_projection") {
            if (formattedVal < validationObj.min_value || formattedVal > validationObj.max_value) {
                return `Value must be between ${validationObj.min_value}% and ${validationObj.max_value}%`;
            }
            return true;
        }
    }


    return (
        <div className="mb-3">
            <label htmlFor={field_id} className="form-label">{field_label}</label>
            <input type="number" step="any" className="form-control" id={field_id}
                inputMode="decimal"
                defaultValue={default_value}
                placeholder={field_placeholder ? field_placeholder : ''}
                key={field_id}
                {...register(field_id, {
                    required: { value: validationObj.required ? validationObj.required : false, message: "This is a required field" },
                    validate: checkMinMaxValue
                })}
            />
            <ErrorMessage
                errors={errors}
                name={field_id}
                render={({ message }) => <p className="fb-error-message">{message}</p>}
            />
            {/* {
                errors[field_id] && errors[field_id]["type"] === "min" && (
                    <div className="error">Your score must be no more than 100</div>
                )
            } */}
        </div>
    )
}

export default Percent